import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

class ReportsCreateShowColumnsModalController {
  static $inject = ['$scope', '$uibModalInstance', 'currentColumns', 'save'];

  model: TODO[] = [];
  cache: TODO[] = [];
  errors: { message: string }[] = [];
  selected = {};
  selectedCount = 0;
  saveLabel = '';

  constructor(
    private $scope: IScope,
    private $uibModalInstance: TODO,
    private currentColumns: TODO[],
    private save: boolean
  ) {}

  $onInit() {
    this.saveLabel = this.save ? 'Save & Preview' : 'Preview';
    this.model = angular.copy(this.currentColumns);
    this.cache = angular.copy(this.currentColumns);
    this.toggleSelected();
  }

  toggleColumn(column) {
    column.selected = !column.selected;
    this.selected[column.name] = column.selected;

    if (this.selected[column.name]) {
      this.selectedCount++;
    } else {
      this.selectedCount--;
    }
  }

  toggleSelected() {
    this.selectedCount = 0;

    for (let i = 0, ii = this.model.length; i < ii; i++) {
      for (let j = 0, jj = this.model[i].fields.length; j < jj; j++) {
        if (this.model[i].selected.hasOwnProperty(this.model[i].fields[j].name)) {
          this.model[i].fields[j].selected = this.model[i].selected[this.model[i].fields[j].name];
          this.selected[this.model[i].fields[j].name] = this.model[i].fields[j].selected;
          if (this.selected[this.model[i].fields[j].name]) {
            this.selectedCount++;
          }
        }
      }
    }
  }

  countSelected() {
    this.selectedCount = 0;

    for (const column in this.selected) {
      if (this.selected.hasOwnProperty(column) && this.selected[column]) {
        this.selectedCount++;
      }
    }

    return this.selectedCount;
  }

  hasSelected() {
    return this.selectedCount > 0;
  }

  hasErrors() {
    return this.errors.length > 0;
  }

  done() {
    this.errors = [];

    if (this.hasSelected()) {
      this.success();
    } else {
      this.errors.push({ message: 'You must select at least one column field' });
    }
  }

  cancel() {
    this.errors = [];
    // Restore cached
    this.model = angular.copy(this.cache);
    this.toggleSelected();
    this.$uibModalInstance.dismiss('cancel');
  }

  success() {
    this.$uibModalInstance.close(this.selected, this.save);
  }
}

export const ReportsCreateShowColumnsModalControllerModule = angular
  .module('acme.view.application.reports.create.showColumnsModal.controllers', [])
  .controller('ReportsCreateShowColumnsModalController', ReportsCreateShowColumnsModalController).name;
